import * as React from 'react';
import { useContext } from 'react';

import ConsumerBffSpecializationContext from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import withGoogleIndiaOverrides from 'bundles/unified-description-page-common/hocs/withGoogleIndiaOverrides';
import type { PropsToComponent as PropsToInnerComponent } from 'bundles/unified-description-page-common/hocs/withGoogleIndiaOverrides';

// Due to use of ConsumerBffSpecializationContext data, this must be wrapped by the ConsumerBffSpecializationDataProvider.
const ConsumerGoogleIndiaOverridesDataProvider = ({ overrides, children }: PropsToInnerComponent) => {
  let context = useContext(ConsumerBffSpecializationContext);
  if (context && overrides) {
    context = {
      ...context,
      specializationPage: context.specializationPage && {
        ...context.specializationPage,
        description: overrides.description,
        cmlDescription: overrides.cmlDescription,
        cmlFaqs: overrides.faqs,
      },
    };
  }

  return (
    <ConsumerBffSpecializationContext.Provider value={context}>{children}</ConsumerBffSpecializationContext.Provider>
  );
};

export default withGoogleIndiaOverrides(ConsumerGoogleIndiaOverridesDataProvider);
